import {Component, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {FeedbackDialogService} from '../../../shared/components/feedback-dialog/feedback-dialog.service';
import {take} from 'rxjs/operators';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  @ViewChild('submitFeedbackButton') submitFeedbackButton: MatButton;


  /**
   * Constructor
   */
  constructor(private feedbackDialogService: FeedbackDialogService) {
  }

  openFeedbackDialog() {
    this.submitFeedbackButton.disabled = true;
    this.feedbackDialogService.openFeedbackDialog().pipe(
      take(1)
    ).subscribe(completed => {
      // this.submitFeedbackButton.disabled = !completed;
      this.submitFeedbackButton.disabled = false;
    });
  }
}
